if ('IntersectionObserver' in window) {
  document.querySelectorAll('.sticky-atc').forEach(function (bar) {
    var sectionId = bar.id.replace('StickyATC-', '');
    var form = document.getElementById('product-form-' + sectionId);
    var trigger = form && form.querySelector('.product-form__submit');
    if (!trigger) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '0px 0px -20% 0px' }
    );
    observer.observe(trigger);
  });
}
